module.exports = __webpack_public_path__ + "static/media/chat-icon.f79927f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chat-icon.svg
// module id = 470
// module chunks = 7